import { render, staticRenderFns } from "./MultiselectDropdown.vue?vue&type=template&id=87b5935c&scoped=true&"
import script from "./MultiselectDropdown.vue?vue&type=script&lang=js&"
export * from "./MultiselectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectDropdown.vue?vue&type=style&index=0&id=87b5935c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b5935c",
  null
  
)

export default component.exports